export { SeatSelectionLandingComponent } from './seatselection-landing.component';
